import request from '@/utils/request'
import { fchown } from 'fs';



// 获取图片验证码[匿名登录用]
export function getCaptchaImage(data) {
	return request({
		url: '/api/common/v1/tool/getCaptchaImage',
		method: 'post',
		data
	})
}

// 发送短信验证码[匿名登录用]
export function getsmsCodeApi(data) {
	return request({
		url: '/api/common/v1/tool/getVerificationCode',
		method: 'post',
		data,
		headers: {
			isToken: false
		}
	})
}

// 给当前用户手机号发送验证码[签署认证用]
export function getSmsVerificationCode(data) {
	return request({
		url: '/api/common/v1/tool/getSmsVerificationCode',
		method: 'post',
		data
	})
}

// 获取签章列表
export function getSealList(data) {
	return request({
		url: '/api/common/v1/seal/list',
		method: 'post',
		data
	})
}







export function getImgCodeApi() {
	///common/imageCode
	return request({
		url: '/captchaImage',
		method: 'get',
	})
}

export function checkImageCodeApi(data) {
	return request({
		url: '/common/checkImageCode',
		method: 'post',
		data
	})
}




export function resetPhone(data) {
	return request({
		url: '/user/center/resetPhone',
		method: 'post',
		data: data
	})
}

export function resetPin(data) {
	return request({
		url: '/user/center/resetPin',
		method: 'post',
		data: data
	})
}

export function checkSmsApi(data) {
	return request({
		url: '/common/checkSms',
		method: 'post',
		data
	})
}

export function getRandomApi() {
	return request({
		url: '/random?nocache=' + new Date().getTime(),
		method: 'get'
	})
}
export function getLoginRandomApi() {
	return request({
		url: '/login/random?nocache=' + new Date().getTime(),
		method: 'get'
	})
}
export function bindKey(data) {
	return request({
		url: '/user/bindKey',
		method: 'post',
		data
	})
}
export function untieKey() {
	return request({
		url: '/user/untieKey',
		method: 'post'
	})
}
export function getEmailCodeApi(data) {
	return request({
		url: '/user/emailCode?email=' + data + '&nocache=' + new Date().getTime(),
		method: 'get'
	})
}

export function getInfoApi() {
	return request({
		url: '/user/info?nocache=' + new Date().getTime(),
		method: 'get'
	})
}

export function getUserSealInfoApi() {
	return request({
		url: '/sealInfo/user?nocache=' + new Date().getTime(),
		method: 'get'
	})
}

export function getCompanySealInfoApi(companyId) {
	return request({
		url: '/sealInfo/company?companyId=' + companyId + '&nocache=' + new Date().getTime(),
		method: 'get'
	})
}

export function getDateApi() {
	return request({
		url: '/common/getDate?nocache=' + new Date().getTime(),
		method: 'get'
	})
}

export function ressetPasswordApi(data) {
	return request({
		url: '/user/modifyUserPwd',
		method: 'post',
		data
	})
}

export function editUserNameApi(data) {
	return request({
		url: '/user/modifyLoginName',
		method: 'post',
		data
	})
}

export function getSMSCodeLoginedApi(data) {
	return request({
		url: '/common/smsCodeLogined?phone=' + data.phone + '&type=' + data.type + '&nocache=' + new Date().getTime(),
		method: 'get'
	})
}

export function getImages(objectName) {
	return request({
		url: '/common/getImages?objectName=' + objectName,
		method: 'get'
	})
}
